import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { ImageThumbnailComponent } from '@web/shared/ui';
import { isNotNil } from '@web/utils';
import { AdminOrderItemComponent } from '../../models/admin-order-item-component';

@Component({
  selector: 'app-admin-order-components-list',
  imports: [ImageThumbnailComponent, NgOptimizedImage],
  templateUrl: './admin-order-components-list.component.html',
  styleUrl: './admin-order-components-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminOrderComponentsListComponent {
  public readonly components = input.required<AdminOrderItemComponent[]>();

  protected readonly isNotNil = isNotNil;

  protected componentTrackFn(
    component: AdminOrderItemComponent,
    index: number,
  ): string {
    return `component_${component.sourceId}_${component.name}_${index}`;
  }
}
